var kosan = kosan || {};

kosan.swiperSection = new function () {
    var self = this;
    var swiper = document.querySelector('.js-swipe-section');
    var prev = document.querySelector('.js-swipe-section-prev');
    var next = document.querySelector('.js-swipe-section-next');
    var bulletsHolder = document.querySelector('.swipe-section-bullets');
    var perPage = 1;

    this.init = function(){
        if(swiper) {
            var mySiema = new Siema({
                selector: '.js-swipe-section',
                duration: 200,
                easing: 'ease-out',
                perPage: {
                    768: 2,
                    1024: 4
                },
                startIndex: 0,
                draggable: true,
                multipleDrag: true,
                threshold: 20,
                onChange: onChange,
                onInit: onInit
            });

            // Arrow buttons for next/prev
          

            prev.addEventListener('click', function() {
                mySiema.prev();
            });
            next.addEventListener('click', function() {
                mySiema.next();
            });
        }


        // Add a function that generates pagination to prototype
        Siema.prototype.addPagination = function() {
            for (var i = 0; i < this.innerElements.length; i++) {
                var btn = document.createElement('button');
                btn.setAttribute('data-id', i);
                btn.setAttribute('aria-label', 'Swipe ' + i);
                btn.className = 'swipe-section-bullet';
                if(i===0) {
                    btn.classList.add('swipe-section-bullet--active');
                }
                btn.addEventListener('click', function(){
                    var id = this.getAttribute('data-id');
                    mySiema.goTo(id);
                });
                bulletsHolder.appendChild(btn);
            }
            
        }

        // Trigger pagination creator
        mySiema.addPagination();  
      
        // Disable prev arrow on init
        function onInit() {
          prev.disabled = true;
        }

        // Update bullets and arrows on change
        function onChange() {
          var index = mySiema.currentSlide;
          prev.disabled = (0 === index);
          next.disabled = (
            index === mySiema.innerElements.length + 1 ||
            index + perPage >= mySiema.innerElements.length
          );
          
          var bullets = document.querySelectorAll('.swipe-section-bullet');
          var activeClass = 'swipe-section-bullet--active';
          var activeBullet = document.querySelector('.'+activeClass);

          // Neutralize
          if(activeBullet){
              activeBullet.classList.remove(activeClass);
          }
          // Activate
          bullets[this.currentSlide].classList.add(activeClass);
        }
    };

}